(ns manage.adset-decision-tree-page.selection
  (:require [manage.adset-decision-tree-page.node-library :as node-library]
            [manage.adset-decision-tree-page.property :as property]
            [mate.core :as mc]))

(defn get-canonical-selected-item [selected-item]
  (some-> selected-item
          (select-keys (case (:type selected-item)
                         :selection/decision-node        [:type :decision-node-id]
                         :selection/outcome-node         [:type :decision-node-id :outcome-node-id]
                         :selection/variant              [:type :decision-node-id :outcome-node-id :variant-id]
                         :selection/product-selector     [:type :decision-node-id :outcome-node-id :variant-id]
                         :selection/default-outcome-node [:type :decision-node-id]))))

(defn get-selected-node-id [selected-item]
  (or (:outcome-node-id selected-item)
      (:decision-node-id selected-item)))

(defn get-host-node-id [selected-item]
  (case (:type selected-item)
    :selection/decision-node (:decision-node-id selected-item)
    :selection/outcome-node (:outcome-node-id selected-item)
    :selection/variant (or (:outcome-node-id selected-item)
                           (:decision-node-id selected-item))
    :selection/default-outcome-node (:decision-node-id selected-item)
    nil))

(defn parent-selected-item [selected-item]
  (-> (case (:type selected-item)
        :selection/decision-node nil
        :selection/outcome-node (-> selected-item
                                    (assoc :type :selection/decision-node))
        :selection/variant (-> selected-item
                               (assoc :type (:parent-type selected-item)))
        :selection/product-selector (-> selected-item
                                        (assoc :type (:parent-type selected-item)))
        :selection/default-outcome-node (-> selected-item
                                            (assoc :type :selection/decision-node))
        nil)
      get-canonical-selected-item))

(def selected-type->node-details
  (->> (conj node-library/nodes
             {:type :selection/variant
              :properties property/ad-variant-properties}
             {:type :selection/default-outcome-node
              :properties [{:id :properties/default-has-no-properties-info}]
              :variant-properties {:default {:single-default-per-dimensions true}}
              :has-variants true})
       (map #(update % :properties property/resolve-properties))
       (mc/index-by :type)))

(def feature-flags
  (into (into #{}
              (keep :feature-flag)
              (vals selected-type->node-details))
        (comp (mapcat :properties) (keep :feature-flag))
        (vals selected-type->node-details)))

(defn get-selection-details
  [{selected-item-type :type} {selected-node-type :type} current-channel flag-values]
  (let [selected-type (if (contains? #{:selection/variant
                                       :selection/default-outcome-node}
                                     selected-item-type)
                        selected-item-type
                        selected-node-type)]

    (-> (get selected-type->node-details selected-type)
        (update :properties
                (fn [properties]
                  (-> properties
                      (property/filter-properties-by-flags flag-values)
                      (property/filter-properties-by-channel current-channel))))
        (update :variant-properties #(get % current-channel (get % :default))))))

(defn get-selected-item-base-path
  [node-data selected-item]
  (when (= (:type selected-item) :selection/variant)
    (concat property/ad-variants-data-path
            [(->> (map-indexed vector (:ad-variants node-data))
                  (some (fn [[index variant]]
                          (when (= (:uuid variant) (:variant-id selected-item))
                            index))))])))

(defn get-selected-item-for-node [{:keys [id parent-id category]}]
  (case category
    (:decision-node :root-node) {:decision-node-id id
                                 :type :selection/decision-node}
    :default-outcome-node {:decision-node-id id
                           :type :selection/default-outcome-node}
    :outcome-node {:decision-node-id parent-id
                   :outcome-node-id id
                   :type :selection/outcome-node}))
